import { render, staticRenderFns } from "./SummaryPricing.vue?vue&type=template&id=0d6aa511&scoped=true&"
import script from "./SummaryPricing.vue?vue&type=script&lang=js&"
export * from "./SummaryPricing.vue?vue&type=script&lang=js&"
import style0 from "./SummaryPricing.vue?vue&type=style&index=0&id=0d6aa511&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d6aa511",
  null
  
)

export default component.exports